module.exports = __webpack_public_path__ + "img/Rogue.180a9ed8.png";